export const landingPageKey = 'landingPageConfig';
export const customDashboardParameterId = 'customDashboardConfig';
export const systemWidgetType = 'systemWidget';
export const defaultLandingPageWidth = '1500px';

export const panelLayouts = [
    {
        position: {
            row: 1,
            rowSpan: 7,
            column: 1,
            columnSpan: 4,
        },
    },
    {
        position: {
            row: 8,
            rowSpan: 7,
            column: 1,
            columnSpan: 4,
        },
    },
    {
        position: {
            row: 1,
            rowSpan: 7,
            column: 5,
            columnSpan: 4,
        },
    },
    {
        position: {
            row: 8,
            rowSpan: 7,
            column: 5,
            columnSpan: 4,
        },
    },
    {
        position: {
            row: 1,
            rowSpan: 7,
            column: 9,
            columnSpan: 4,
        },
    },
    {
        position: {
            row: 8,
            rowSpan: 7,
            column: 9,
            columnSpan: 4,
        },
    },
];
